<template>
  <div class="job-category-line-menu" data-testid="row-actions">
    <OrgObjectActionsMenu
      objectType="job_category"
      :status="normalizedStatus"
      :objectSpecificActions="objectSpecificActions"
      @action="handleAction"
    />
  </div>
</template>

<script>
export default {
  name: "JobCategoryLineMenu",
};
</script>

<script setup>
import { computed } from "vue";
import OrgObjectActionsMenu from "@components/OrgObjectActionsMenu/OrgObjectActionsMenu.vue";

const props = defineProps({
  category: { type: Object, default: () => ({}) },
  status: { type: String, default: "draft" },
  archived: { type: Boolean, default: false },
  positionCount: { type: Number, default: 0 },
});

const emit = defineEmits(["action"]);

// Normalize status: lowercase to Title case for OrgObjectActionsMenu validator
const normalizedStatus = computed(() => {
  const status = String(props.status || "draft").trim().toLowerCase();
  // archived prop overrides status for display purposes
  if (props.archived) return "Archived";
  // Map status to canonical lifecycle states
  if (status === "active") return "Active";
  if (status === "retired") return "Retired";
  if (status === "draft") return "Draft";
  // archived checked above, fallback to Active
  return "Active";
});

// Job Category-specific action: Edit (always first)
const objectSpecificActions = computed(() => [
  {
    name: "Edit",
    value: "edit",
    icon: "icons/dropdown/edit.svg",
    destructive: false,
  },
]);

function handleAction(actionValue) {
  emit("action", { type: actionValue, category: props.category });
}
</script>

<style scoped>
.job-category-line-menu {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
